<template>
  <div class="modern-sponsors-showcase">
    <!-- Section Header -->
    <div class="showcase-header">
      <div class="header-icon-wrapper">
        <v-icon color="white" size="36">mdi-handshake</v-icon>
      </div>
      <div class="header-text">
        <h2 class="showcase-title">Our Valued Sponsors</h2>
      </div>
    </div>

    <!-- Marquee Container -->
    <div class="marquee-container">
      <div class="marquee-content">
        <!-- First set of sponsors -->
        <div
          v-for="(sponsor, index) in [...sponsors, ...sponsors]"
          :key="`sponsor-${index}`"
          class="sponsor-item"
        >
          <div class="modern-sponsor-card">
            <div class="sponsor-card-inner">
              <v-img
                :src="sponsor.url"
                class="sponsor-image"
                contain
              ></v-img>
              <div class="sponsor-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- View All Button -->
    <div class="view-all-wrapper">
      <v-btn
        class="view-all-btn"
        elevation="0"
        large
        @click="navigateTo()"
      >
        <v-icon left>mdi-eye</v-icon>
        View All Our Sponsors
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sponsors: [
        { url: 'https://cltts-gallery.s3.amazonaws.com/sponsors/Exotica.jpeg' },
        { url: 'https://cltts-gallery.s3.amazonaws.com/sponsors/nalan_home.jpeg' },
        { url: 'https://cltts-gallery.s3.amazonaws.com/sponsors/Balasure.jpg' },
        { url: 'https://cltts-gallery.s3.amazonaws.com/sponsors/eesha.PNG' },
        { url: 'https://cltts-gallery.s3.amazonaws.com/sponsors/KhannaSonsJewellers.jpeg' },
        { url: 'https://cltts-gallery.s3.amazonaws.com/sponsors/Finzly.png' },
        { url: 'https://cltts-gallery.s3.amazonaws.com/sponsors/NHR.jpeg' },
        { url: 'https://cltts-gallery.s3.amazonaws.com/sponsors/Balasure_2.jpg' },
        { url: 'https://cltts-gallery.s3.amazonaws.com/sponsor2025/raghureality.png' }
      ]
    }
  },
  methods: {
    navigateTo() {
      this.$router.replace('/Sponsors')
    }
  }
}
</script>

<style scoped lang="scss">
* {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

/* Modern Sponsors Showcase */
.modern-sponsors-showcase {
  background: linear-gradient(135deg, #4a5a8f 0%, #3d5a8c 50%, #2e6ba8 100%) !important;
  padding: 32px 0 !important;
  position: relative !important;
  overflow: hidden !important;
}

.modern-sponsors-showcase::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 4px !important;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #8ebf42 100%) !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

/* Showcase Header */
.showcase-header {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 16px !important;
  margin-bottom: 24px !important;
  flex-wrap: wrap !important;
  padding: 0 24px !important;
}

.header-icon-wrapper {
  width: 56px !important;
  height: 56px !important;
  border-radius: 14px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 8px 24px rgba(102, 126, 234, 0.5),
    inset 0 2px 4px rgba(255, 255, 255, 0.2) !important;
  position: relative !important;
  overflow: hidden !important;
}

.header-icon-wrapper::before {
  content: '' !important;
  position: absolute !important;
  top: -50% !important;
  left: -50% !important;
  width: 200% !important;
  height: 200% !important;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent) !important;
  transform: rotate(45deg) !important;
  animation: shimmer 3s infinite !important;
}

.header-text {
  text-align: center !important;
}

.showcase-title {
  font-size: 28px !important;
  font-weight: 800 !important;
  color: white !important;
  margin: 0 !important;
  letter-spacing: -0.5px !important;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

.showcase-subtitle {
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.85) !important;
  margin: 6px 0 0 0 !important;
  font-weight: 600 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
}

/* Marquee Container */
.marquee-container {
  width: 100% !important;
  overflow: hidden !important;
  padding: 16px 0 !important;
  position: relative !important;
}

.marquee-container::before,
.marquee-container::after {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  width: 200px !important;
  height: 100% !important;
  z-index: 2 !important;
  pointer-events: none !important;
}

.marquee-container::before {
  left: 0 !important;
  background: linear-gradient(90deg,
    rgba(74, 90, 143, 1) 0%,
    rgba(74, 90, 143, 0) 100%) !important;
}

.marquee-container::after {
  right: 0 !important;
  background: linear-gradient(270deg,
    rgba(74, 90, 143, 1) 0%,
    rgba(74, 90, 143, 0) 100%) !important;
}

.marquee-content {
  display: flex !important;
  gap: 32px !important;
  animation: marqueeScroll 30s linear infinite !important;
  will-change: transform !important;
}

.marquee-content:hover {
  animation-play-state: paused !important;
}

.sponsor-item {
  flex-shrink: 0 !important;
}

/* Modern Sponsor Card */
.modern-sponsor-card {
  width: 240px !important;
  height: 140px !important;
  border-radius: 20px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 100%) !important;
  backdrop-filter: blur(20px) !important;
  border: 2px solid rgba(255, 255, 255, 0.15) !important;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 2px 4px rgba(255, 255, 255, 0.1) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.modern-sponsor-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 3px !important;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #8ebf42 100%) !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.modern-sponsor-card:hover {
  transform: translateY(-8px) scale(1.05) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  box-shadow:
    0 16px 48px rgba(0, 0, 0, 0.4),
    0 0 40px rgba(102, 126, 234, 0.3),
    inset 0 2px 4px rgba(255, 255, 255, 0.2) !important;
}

.sponsor-card-inner {
  position: relative !important;
  width: 100% !important;
  height: 100% !important;
  padding: 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important;
}

.sponsor-image {
  width: 100% !important;
  height: 100% !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  filter: brightness(1.1) contrast(1.1) !important;
}

.modern-sponsor-card:hover .sponsor-image {
  transform: scale(1.1) !important;
  filter: brightness(1.2) contrast(1.2) !important;
}

.sponsor-overlay {
  position: absolute !important;
  inset: 0 !important;
  background: linear-gradient(135deg,
    rgba(102, 126, 234, 0) 0%,
    rgba(118, 75, 162, 0.1) 100%) !important;
  opacity: 0 !important;
  transition: opacity 0.4s ease !important;
}

.modern-sponsor-card:hover .sponsor-overlay {
  opacity: 1 !important;
}

/* View All Button */
.view-all-wrapper {
  display: flex !important;
  justify-content: center !important;
  margin-top: 24px !important;
  padding: 0 24px !important;
}

.view-all-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  padding: 16px 40px !important;
  border-radius: 50px !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow:
    0 8px 24px rgba(102, 126, 234, 0.5),
    0 0 40px rgba(102, 126, 234, 0.2),
    inset 0 2px 4px rgba(255, 255, 255, 0.2) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.view-all-btn::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: -100% !important;
  width: 100% !important;
  height: 100% !important;
  background: linear-gradient(90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent) !important;
  transition: left 0.5s ease !important;
}

.view-all-btn:hover::before {
  left: 100% !important;
}

.view-all-btn:hover {
  transform: translateY(-4px) scale(1.05) !important;
  box-shadow:
    0 12px 40px rgba(102, 126, 234, 0.6),
    0 0 60px rgba(102, 126, 234, 0.3),
    inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
}

/* Animations */
@keyframes gradientFlow {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

@keyframes marqueeScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .modern-sponsors-showcase {
    padding: 28px 0 !important;
  }

  .showcase-header {
    margin-bottom: 20px !important;
  }

  .header-icon-wrapper {
    width: 64px !important;
    height: 64px !important;
  }

  .header-icon-wrapper .v-icon {
    font-size: 32px !important;
  }

  .showcase-title {
    font-size: 30px !important;
  }

  .showcase-subtitle {
    font-size: 15px !important;
  }

  .modern-sponsor-card {
    width: 220px !important;
    height: 130px !important;
  }

  .sponsor-card-inner {
    padding: 18px !important;
  }

  .marquee-content {
    gap: 24px !important;
  }

  .view-all-wrapper {
    margin-top: 28px !important;
  }

  .view-all-btn {
    font-size: 15px !important;
    padding: 16px 36px !important;
  }
}

@media (max-width: 600px) {
  .modern-sponsors-showcase {
    padding: 24px 0 !important;
  }

  .showcase-header {
    margin-bottom: 20px !important;
    gap: 12px !important;
  }

  .header-icon-wrapper {
    width: 48px !important;
    height: 48px !important;
  }

  .header-icon-wrapper .v-icon {
    font-size: 24px !important;
  }

  .showcase-title {
    font-size: 22px !important;
  }

  .showcase-subtitle {
    font-size: 13px !important;
  }

  .marquee-container {
    padding: 12px 0 !important;
  }

  .marquee-container::before,
  .marquee-container::after {
    width: 60px !important;
  }

  .modern-sponsor-card {
    width: 160px !important;
    height: 100px !important;
    border-radius: 16px !important;
  }

  .modern-sponsor-card::before {
    height: 2px !important;
  }

  .sponsor-card-inner {
    padding: 14px !important;
  }

  .marquee-content {
    gap: 16px !important;
    animation: marqueeScroll 20s linear infinite !important;
  }

  .view-all-wrapper {
    margin-top: 20px !important;
  }

  .view-all-btn {
    font-size: 14px !important;
    padding: 14px 28px !important;
  }

  .view-all-btn .v-icon {
    font-size: 18px !important;
  }
}
</style>